import { IconFileNames } from '../components/icons/SVGIcon';

import { mapMimeTypeToSVGIconName } from './mapMimeTypeToSVGIconName';

const isSupportedFileIcon = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  icon: any
): icon is (typeof IconFileNames)[number] => IconFileNames.includes(icon);

export function getSVGIconNameFromDocument({
  fileName,
  mimetype,
}: {
  fileName: string;
  mimetype?: string | null;
}) {
  if (mimetype) {
    return mapMimeTypeToSVGIconName(mimetype);
  }

  // If no mimetype is provided, we use the file extension to determine the icon (fallback)
  const fileIconName = `file-${fileName.split('.').pop()?.toLowerCase()}`;
  return isSupportedFileIcon(fileIconName) ? fileIconName : 'file-unknown';
}
